/* eslint-disable @typescript-eslint/no-explicit-any */
import * as axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import QGContext from "../../QGContext";
import { useContext } from "react";

/**
 * Deletes the validation set from the project
 *
 * @param {string} projectId The projectId Id
 * @returns {Promise<any>} The response from the Quality Gate API
 */
export const useDeleteValidationSet = (projectId: string) => 
{
  const ctx = useContext(QGContext);
  const queryClient = useQueryClient();

  return useMutation({
    // TODO typing
    mutationFn: async (validationSetId: string) => 
    {
      const response = await axios.default.delete(
        // TODO remove parent ("root") from backend
        `/qualitygate/v1/validationSets/${projectId}/root/${validationSetId}`,
        {
          headers: {
            userToken: ctx.tokens.idToken,
            accessToken: ctx.tokens.accessToken,
          },
        },
      );

      return response.data;
    },
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: ["getValidationSets", projectId],
      }),
  });
};